import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { PartialDamageReportCreateRequestInterface } from '../definitions/partial-damage-report-create-request.interface';

@Injectable({ providedIn: 'root' })
export class PartialDamageReportCreateService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public create(taskId: string, data: PartialDamageReportCreateRequestInterface): Observable<string> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/partial-damage-reports`;

    return this.client.post(url, data, { responseType: 'text' }).pipe(
      catchError(error => throwError(handleProblem(error)))
    ) as Observable<string>;
  }
}
